import { render } from "./FollowUpRating.vue?vue&type=template&id=357c8ac9&scoped=true"
import script from "./FollowUpRating.vue?vue&type=script&lang=js"
export * from "./FollowUpRating.vue?vue&type=script&lang=js"

import "./FollowUpRating.vue?vue&type=style&index=0&id=357c8ac9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357c8ac9"]])

export default __exports__